import { useEffect, useRef } from 'react';
import heroImg from '../../assets/images/saladin_hero.png';
import './Hero.css';

const Hero = () => {
    const headingRef = useRef(null);

    useEffect(() => {
        const el = headingRef.current;
        if (el) {
            el.style.animationPlayState = 'running';
        }
    }, []);

    const scrollToOverview = () => {
        const el = document.getElementById('overview');
        if (el) el.scrollIntoView({ behavior: 'smooth' });
    };

    return (
        <section id="hero" className="hero">
            <div className="hero__bg">
                <div className="hero__bg-gradient"></div>
                <div className="hero__bg-pattern"></div>
                <div className="hero__bg-vignette"></div>
            </div>

            <div className="hero__ornaments">
                <div className="hero__ornament hero__ornament--1">✦</div>
                <div className="hero__ornament hero__ornament--2">☽</div>
                <div className="hero__ornament hero__ornament--3">✦</div>
                <div className="hero__ornament hero__ornament--star"></div>
            </div>

            <div className="hero__container">
                <div className="hero__text">
                    <span className="section-tag hero__tag">Sultan of Egypt &amp; Syria</span>
                    <h1 ref={headingRef} className="hero__title">
                        <span className="hero__title-arabic">صلاح الدين</span>
                        <span className="hero__title-main">Salah Eldin</span>
                        <span className="hero__title-sub">El-Ayoubi</span>
                    </h1>
                    <div className="hero__divider">
                        <span className="hero__divider-left"></span>
                        <span className="hero__divider-icon">✦</span>
                        <span className="hero__divider-right"></span>
                    </div>
                    <p className="hero__desc">
                        The great Muslim sultan who united the Islamic world,
                        led the legendary Battle of Hattin, and liberated the
                        holy city of Jerusalem from Crusader rule in 1187 CE.
                    </p>
                    <div className="hero__dates">
                        <div className="hero__date">
                            <span className="hero__date-year">1137</span>
                            <span className="hero__date-label">Born in Tikrit</span>
                        </div>
                        <div className="hero__date-divider">→</div>
                        <div className="hero__date">
                            <span className="hero__date-year">1187</span>
                            <span className="hero__date-label">Liberation of Jerusalem</span>
                        </div>
                        <div className="hero__date-divider">→</div>
                        <div className="hero__date">
                            <span className="hero__date-year">1193</span>
                            <span className="hero__date-label">Passed to Mercy</span>
                        </div>
                    </div>
                    <button className="hero__cta" onClick={scrollToOverview}>
                        Discover His Legacy
                        <span className="hero__cta-arrow">↓</span>
                    </button>
                </div>

                <div className="hero__portrait-wrapper">
                    <div className="hero__portrait-frame">
                        <div className="hero__portrait-ring hero__portrait-ring--1"></div>
                        <div className="hero__portrait-ring hero__portrait-ring--2"></div>
                        <img
                            src={heroImg}
                            alt="Portrait of Salah Eldin El-Ayoubi"
                            className="hero__portrait-img"
                        />
                        <div className="hero__portrait-glow"></div>
                    </div>
                    <p className="hero__portrait-caption">
                        ﷺ&nbsp; The Honorable Sultan &nbsp;ﷺ
                    </p>
                </div>
            </div>

            <div className="hero__scroll-indicator">
                <div className="hero__scroll-line"></div>
                <span className="hero__scroll-text">Scroll</span>
            </div>
        </section>
    );
};

export default Hero;
